import { AuthService } from '@auth0/auth0-angular';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, tap } from 'rxjs';
import { AuthActions } from './auth.actions';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthEffects {
  constructor(private actions$: Actions, private authService: AuthService) {}

  login$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.login),
        tap(({ target }) =>
          this.authService.loginWithRedirect({
            authorizationParams: {
              redirect_uri: window.location.origin,
            },
            appState: { target },
          })
        )
      ),
    { dispatch: false }
  );

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.logout),
      mergeMap(() =>
        this.authService
          .logout({
            logoutParams: { returnTo: document.location.origin },
          })
          .pipe(map(() => AuthActions.logoutSuccess()))
      )
    )
  );

  signup$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.signup),
        tap(({ target }) =>
          this.authService.loginWithRedirect({
            authorizationParams: {
              redirect_uri: window.location.origin,
              screen_hint: 'signup',
            },
            appState: { target },
          })
        )
      ),
    { dispatch: false }
  );
}
